import './App.css';
import {
  withAITracking,
  AppInsightsErrorBoundary,
} from "@microsoft/applicationinsights-react-js";
import ReactDOM from "react-dom";
import React, { createContext, Fragment, FunctionComponent, useReducer, useState } from "react";
import { Switch, Route, Link, BrowserRouter, Redirect } from "react-router-dom";
import { allTabs, getCategoryMap, getDraftMode, setAccountIdentifier, getFirstName, getMiddleName, getSubmitMode, getUserInfo, setUserInfo, setDraftSubmitMode, setNominatorId, setNominatorMail,  setNominatorName, getToken, setReportURL, setInstrumentationKey, setemailNotificationEabled,setIsLangHdr, setUserGraphId } from "./components/common";
import Header from "./components/Header";
import Admin from "./components/Admin";
import HomePage from "./components/HomePage";
import NomDashboard from "./components/NominationDashboard";
import NominationEditor from "./components/NominationEditor";
import ThoughtStarters from "./components/ThoughtStarters";
import { useEffect } from 'react';
import { getInstrumentationKey, getReportUrl, getCategoryDetails, getFeatureNames, getManagerInfo, getNominatorId, getNominatorInfo, getUserCity, getUserCompany, getUserRoleId } from './components/services';
import FaqDetails from './components/FaqDetails';
import ThankYou from './components/ThankYou';
import { Provider } from 'react-redux'
import { store } from './store/store'
import Error from "./Error";
import Loader from "./Loader";
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import PropTypes from 'prop-types';
import AddAdmin from './components/AddAdmin';
import AddAwardee from './components/AddAwardee';
import ViewNominations from './components/ViewNominations';
import NomSettings from './components/NomSettings';
import { ThemeProvider } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import { reactPlugin, appInsights } from "./AppInsights";
import { Box, createTheme } from '@mui/material';
import { useMsal } from '@azure/msal-react';
import { jwtTokenRequest } from './authConfig';

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any; }) {


  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

function App(props: any) {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  
  let history: any = useHistory()
  const [token, setToken] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);
  const [showTab, setShowTab] = useState<boolean>(false);
  
  const accountIdentifier = account?.localAccountId || account?.homeAccountId?.split('.')[0] || '';
  
  useEffect(() => {
      getToken().then((token: any) => {
          setToken(token);
      });
  }, [])

  useEffect(() => {
    getReportUrl().then((data:any) => {
      setReportURL(data);
    })
  }, [])

  useEffect(() => {
    getInstrumentationKey().then((token: any) => {
        setInstrumentationKey(token);
    });
}, [])
 
  const featureFlags:any = sessionStorage.getItem("featureFlags") ;

  useEffect(() => {
    if (accountIdentifier) {
      getUserEmail().then((response: any) => {
        let userEmail = response?.mail;
        if (userEmail != undefined) {
          getUserRoleId(userEmail).then((response: any) => {
            if (response == 1) {
              setShowTab(true);
            }
            else {
              setShowTab(false);
            }
          });
        }
      });
    }
  }, [accountIdentifier])

  async function getUserEmail() {
    let userInfo: any = await getNominatorInfo(accountIdentifier);
    return userInfo;
  }

  useEffect(() => {

    if (token && account && accountIdentifier) {
      setUserId(accountIdentifier);
      setUserGraphId(accountIdentifier);
      // Set user info for backward compatibility with common.ts
      setUserInfo({ account: account });
      setAccountIdentifier(account);
    }

  }, [token, account, accountIdentifier]);

  const [showNominatons, setNominationsVisibility] = useState<boolean>(false);
  
  const getUserAndManagerInfo = async () => {
    if (!accountIdentifier) {
      console.log('No account identifier available');
      return;
    }
    
    try {
      let userInfo: any = await getNominatorInfo(accountIdentifier);
      let managerInfo: any = await getManagerInfo(accountIdentifier);
      let userInfoCompany: any = await getUserCompany(accountIdentifier);
      let userInfoCity: any = await getUserCity(accountIdentifier);
      let categoryInfo: any = await getCategoryDetails();
      let roleInfo:any= await getUserRoleId(userInfo.mail);
      const { displayName, mail,givenName,surname, officeLocation, jobTitle } = userInfo;
      
     

        let options = {
          "firstName": givenName,//getFirstName(displayName.split(',')[1]),
          "lastName": surname,//displayName.split(',')[0].trim(),
          "middleName": '',
          "displayName":displayName,
          "email": mail,
          "city": userInfoCity.value,
          "company": userInfoCompany.value,
          "title": jobTitle,
          "managerName": managerInfo.displayName,
          "managerEmail": managerInfo.mail,
          "graphId": accountIdentifier,
          "RoleId":roleInfo==0?2:roleInfo
        }
      let nominatorId: any = await getNominatorId(options);
      setNominatorId(nominatorId.id);
      setNominatorName(givenName+" "+surname);
      setNominationsVisibility(true);
      setNominatorMail(mail);
      setDraftSubmitMode(categoryInfo.category);
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  }

  useEffect(() => {
    if (accountIdentifier) {
      getUserAndManagerInfo()
    }
  }, [accountIdentifier])

  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  
const setLangHeader=()=>{
  setIsLangHdr(true);
}
  const [showBar, setShowBar] = useState<boolean>(false);


  const redirectMe = (url:any) => {
    window.location.href = url;}

  const customTheme = createTheme({
    palette: {
      primary: {
        light: "#42c2f5",
        main: "#FFFFFF",
        dark: "#778899",
        contrastText: "#fff"
      }
    }
  });

  const theme = useTheme();

  const classes = useStyles();

  return (
    <div className="loadAppInsights" id="loadAppInsights">
    <AppInsightsErrorBoundary
      onError={() => <h1>Checking error..</h1>}
      appInsights={reactPlugin}
    >
      <Provider store={store}>
        <BrowserRouter>
          <div className="App" id="app">
            <Route
              path="/"
              render={({ location }: any) => (
                <Fragment>
                  <Header />
                  <div >
                    <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}>

                      <ThemeProvider theme={customTheme}>
                        <Tabs
                          orientation="vertical"
                          value={value}
                          variant="standard"
                          onChange={handleChange}
                          textColor="primary"
                          className={classes.root}
                          classes={{ indicator: classes.indicator }}>

                          <Tab label="VIA" className={classes.tabStyle} {...a11yProps(0)} onClick={() => redirectMe('/')}/>
                          {showTab?
                          <Tab label="Admin" className={classes.tabStyle} onClick={setLangHeader}{...a11yProps(1)} /> : ""}
                        
                        </Tabs>
                        <TabPanel value={value} index={0} className={classes.tab}>
                          <Switch>
                            <Route path={allTabs[0]} exact component={HomePage} />
                            <Route path={allTabs[1]} component={NominationEditor} />
                            <Route path={allTabs[2]} component={NomDashboard} />
                            <Route path={allTabs[3]} component={ThoughtStarters} />
                            <Route path={allTabs[4]} component={FaqDetails} />
                            <Route path={allTabs[5]} component={ThankYou} />
                          </Switch>
                        </TabPanel>
                        <TabPanel value={value} index={1} className={classes.tab}>
                          <Admin />
                        </TabPanel>
                      </ThemeProvider>
                    </Box>
                  </div>
                  <Loader/>
                </Fragment>
              )}
            />
            <Error />
           
          </div>
        </BrowserRouter>
      </Provider>
    </AppInsightsErrorBoundary>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#00338e',
      overflow: 'visible'
    },
    tabStyle: {
      color: '#FFFFFF',
      fontFamily: 'Barlow !important',
      wordWrap: 'break-word',
      fontSize: '18px',
      alignContent: 'center',
      "&.MuiButtonBase-root.MuiTab-root": {
        minHeight: '15vh',
        height: '20vh',
        minWidth: '7vw'
      },
      [theme.breakpoints.down(650)]: {
        fontSize: '12px',   
        "&.MuiButtonBase-root.MuiTab-root": {
          minHeight: '8vh',
          height: '10vh',
          minWidth: '3vw'
        },              
      }
    },
    
    tab: {
      width: '100%',
      '& .MuiBox-root': {
        padding: '0px',
      },
    },
    indicator: {
      display: 'none'
    }
  }),
);

export default App;


